enum ZonePointType {
  CleaningZoneCorner,
  CleaningZoneStartPosition,
  CleaningZoneMidPoint,
  TeachAndRepeatZoneCorner,
  TeachAndRepeatZoneStartPosition,
  TeachAndRepeatZoneMidPoint,
  RedZoneCorner,
  RedZoneMidPoint,
  RuleZoneCorner,
  RuleZoneMidPoint,
  MapOrigin,
  WayPoint,
  LandmarkPoint,
  GatePoint,
  RoomLimitZonePoint,
  RoomLimitZonePointMidPoint,
  TeachAndRepeatZonePathPoint,
  TeachAndRepeatZonePathMidPoint,
}

export enum SimpleZonePointType {
  CornerPoint,
  CleaningZoneStartPosition,
}

export default ZonePointType;
